package fr.manyverse.app.presentation.navigation

import kotlinx.serialization.Serializable

// Auth routes
@Serializable
data object OnboardingRoute

@Serializable
data object WelcomeRoute

@Serializable
data object CharacterListRoute

@Serializable
data object CreateCharacterRoute

@Serializable
data class EditCharacterRoute(val characterId: String)

@Serializable
data object CreateGameRoute

@Serializable
data object GameConfigurationRoute

@Serializable
data class ActiveGameRoute(val tableId: String, val universeId: String)

@Serializable
data class PreMadeCharactersRoute(
    val tableId: String,
    val themeId: String,
    val themeSeedColor: Long?,
    val isFreeConstruction: Boolean,
    val isCharacterSheetAvailable: Boolean
)

@Serializable
data class GmInventoryRoute(
    val tableId: String,
    val themeId: String,
    val themeSeedColor: Long?
)

@Serializable
data object UniversesListRoute

@Serializable
data object CreateUniverseRoute

@Serializable
data class EditUniverseRoute(val universeId: String)

@Serializable
data class FeedbackRoute(val type: String)
